import React, { Component } from 'react';

import { Container } from 'reactstrap';

import './NewsListItem.css'

class NewsListItem extends Component {
    render() {
        const { title, content, background, createdByUserName, creationDate, lastModifiedByUserName, lastModificationDate, url } = this.props;

        const news_text = (
            <div className="news-text left-0 text-center bg-faded p-5 rounded">
                <h2 className="section-heading mb-4">{title}</h2>
                <p className="mb-3">{content}</p>
                <div className="author-and-date">
                    Közzétette {createdByUserName} {new Date(creationDate).toLocaleString("hu")}-kor<br />
                    {lastModifiedByUserName ? <span>Utoljára módosította {lastModifiedByUserName} {new Date(lastModificationDate).toLocaleString("hu")}-kor</span> : null}
                </div>
            </div>
        );

        return (
            <section className="page-section clearfix">
                <Container>
                    <div className="news">
                        <div className="news-img mb-3 mb-lg-0 rounded"
                             style={{backgroundImage: !!background ? `url(${background})` : `url('/assets/generic_preview.jpg')`}}>
                        </div>
                        {
                            url && url.length > 0 ?
                                <a href={url}>{news_text}</a> :
                                news_text
                        }
                    </div>
                </Container>
            </section>
        );
    }
}

export default NewsListItem;
